import { gql } from '@apollo/client';

export const CREATE_EXTENSION_AUTH_CODE = gql`
    mutation($data: CreateExtensionAuthCodeInput!) {
        createExtensionAuthCode(data: $data) {
            __typename
            ... on ExtensionAuthCodePayload {
                code
                expiresInSeconds
            }
            ... on ExtensionAuthCodeError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
